import React, {useEffect, useRef} from 'react';
import {createPortal} from "react-dom";

const Modal = ({children, open}) => {
    const dialog = useRef(null);

    useEffect(() => {
        if (open) {
            dialog.current.showModal()
        } else dialog.current.close()
    }, [open])

    return createPortal(<dialog ref={dialog}><div id="flex">{children}</div></dialog>,
        document.getElementById("modal"))
};

export default Modal;